import { render, staticRenderFns } from "./ModalFormRejected.vue?vue&type=template&id=a06a0a34&scoped=true&"
import script from "./ModalFormRejected.vue?vue&type=script&lang=js&"
export * from "./ModalFormRejected.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormRejected.vue?vue&type=style&index=0&id=a06a0a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a0a34",
  null
  
)

export default component.exports